var config = {
  apiKey: "AIzaSyCH_iWQnboGxikkqiQVVo6pV7LJHQRknjM",
  authDomain: "kojishin-fce4e.firebaseapp.com",
  databaseURL: "https://kojishin-fce4e.firebaseio.com",
  storageBucket: "",
};
firebase.initializeApp(config);



//////////////////
// WEBPACK FOOTER
// ./app/firebase-init.js
// module id = 82
// module chunks = 0